import { SET_ACCESS_TOKEN, SET_PROFILE_PIC_ACCESS_TOKEN } from 'redux/reduxConstants';

export function setAccessToken(access_token: string, expiresOn: Date) {
	return { type: SET_ACCESS_TOKEN, access_token, expiresOn };
}

export function setProfilePicAccessToken(access_token: string, expiresOn: Date) {
	return { type: SET_PROFILE_PIC_ACCESS_TOKEN, access_token, expiresOn };
}
